module.exports = __webpack_public_path__ + "img/projetos_black.f0aaf592.png";